export let history =[
    {
        "Commercial":"Fullname commercial 1",
        "Action":"Visit de proposition",
        "Client":"RS Client Y",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Planifiée",
           
    },
    {
        "Commercial":"Fullname commercial 2",
        "Action":"Visit de proposition",
        "Client":"RS Client X",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"En cours",
           
    },
    {
        "Commercial":"Fullname commercial 3",
        "Action":"Visit de proposition",
        "Client":"RS Client Y",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"En cours",
           
    },
    {
        "Commercial":"Fullname commercial 4",
        "Action":"Visit de proposition",
        "Client":"RS Client X",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Effectuée",
           
    },{
        "Commercial":"Fullname commercial 5",
        "Action":"Visit de proposition",
        "Client":"RS Client Y",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Effectuée",
           
    }
    ,{
        "Commercial":"Fullname commercial 6",
        "Action":"Visit de proposition",
        "Client":"RS Client X",
        "Dateaction":"01/02/2020 - 11:00",
        "Status":"Effectuée",
           
    }
]